import { Category, CATEGORIES, Participant, Role, ROLES, User } from '@core/data/models'

/** Avatar por defecto cuando el participante no ha subido foto. */
export const DEFAULT_AVATAR = 'https://secure.gravatar.com/avatar/f7219bbd71f453e41750fa3c63a11da1?size=64&default=mm'

/** Los centros de consumo se identifican con tags `cdc_1`, `cdc_2`… */
const VENUE_TAG_PREFIX = 'cdc'

const ROLE_VALUES = Object.values(ROLES)
const CATEGORY_VALUES = Object.values(CATEGORIES)

/** El rol llega entre los tags del participante, mezclado con los demás. */
function toRole(tags: string[] = []): Role | null {
  return ROLE_VALUES.find(role => tags.includes(role)) ?? null
}

function toCategory(category: string): Category | null {
  return CATEGORY_VALUES.find(value => value === category) ?? null
}

/** Los tags de centro conviven con el rol y con `admin`, que aquí no importan. */
function toVenueTags(tags: string[] = []): string[] {
  return tags.filter(tag => tag.startsWith(VENUE_TAG_PREFIX))
}

export function userAdapter(participant: Participant): User {
  return {
    uid: participant.uid,
    name: participant.name,
    firstName: participant.first_name ?? '',
    lastName: participant.last_name ?? '',
    // Las campañas que no piden correo no lo devuelven.
    email: participant.email ?? '',
    avatar: participant.avatar || participant.picture_url || DEFAULT_AVATAR,
    authenticated: participant.authenticated ?? false,
    role: toRole(participant.tags),
    category: toCategory(participant.category),
    points: participant.points ?? 0,
    venueTags: toVenueTags(participant.tags)
  }
}
